import { render, staticRenderFns } from "./WZDkaipiao.vue?vue&type=template&id=22b5dc82&scoped=true&"
import script from "./WZDkaipiao.vue?vue&type=script&lang=js&"
export * from "./WZDkaipiao.vue?vue&type=script&lang=js&"
import style0 from "./WZDkaipiao.vue?vue&type=style&index=0&id=22b5dc82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5dc82",
  null
  
)

export default component.exports